import { render, staticRenderFns } from "./communityvolunteer.vue?vue&type=template&id=f113b8f2&scoped=true&"
import script from "./communityvolunteer.vue?vue&type=script&lang=js&"
export * from "./communityvolunteer.vue?vue&type=script&lang=js&"
import style0 from "./communityvolunteer.vue?vue&type=style&index=0&id=f113b8f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f113b8f2",
  null
  
)

export default component.exports